import i18n from "i18next";
import HttpApi from "i18next-http-backend";

const savedLanguage =
  localStorage.getItem("language") ||
  localStorage.getItem("appLanguage") ||
  "ko";

i18n.use(HttpApi).init({
  lng: savedLanguage,
  fallbackLng: "ko",
  debug: true,
  ns: [
    "components/audiobook/recording",
    "components/audiobook/audioBookSelectionModal",
    "components/audiobook/completeMakeAudioBook",
    "components/audiobook/selectAIVoice",
    "components/audiobook/selectMode",
    "components/audiobook/recordingCountdown",
    "components/audiobook/saveRecordingModal",
    "components/audiobook/recordingReview",
    "components/creating/branchModal",
    "components/creating/confirmModal",
    "components/creating/completeModal",
    "components/flipbook/flipbook",
    "components/reading/finalReadingModal",
    "components/selectbook/inputName",
    "components/selectbook/insertPicture",
    "components/selectbook/selectDrawType",
    "components/selectbook/selectGender",
    "components/selectbook/selectOption",
    "components/selectbook/selectStory",
    "components/selectbook/selectType",
    "components/utils/backgroundModal",
    "components/utils/customCompleteModal",
    "components/utils/customStartModal",
    "components/utils/header",
    "components/utils/finalModal",
    "components/utils/imageComparisonModal",
    "components/utils/listLoading",
    "components/utils/loading",
    "components/utils/novelFinalModal",
    "components/utils/ongoingModal",
    "components/utils/pagination",
    "components/utils/qxQuizLoading",
    "components/utils/slidePuzzleLoading",
    "components/utils/storyContentToggle",
    "components/audiobook/confirmAudioBookModal",
    "pages/audioReading",
    "pages/making",
    "pages/myStorybook",
    "pages/storyLand",
    "pages/selecting",
  ],
  defaultNS: "components/utils/header",
  interpolation: {
    escapeValue: false,
  },
  backend: {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
  },
  react: {
    useSuspense: false,
  },
});

export const changeAppLanguage = (languageCode) => {
  localStorage.setItem("language", languageCode);
  return i18n.changeLanguage(languageCode);
};

export default i18n;
